import {
  EDITOR_LOAD_LAYOUTS_BEGIN,
  EDITOR_LOAD_LAYOUTS_SUCCESS,
  EDITOR_LOAD_LAYOUTS_FAILURE,
  EDITOR_LOAD_LAYOUTS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadLayouts(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_LOAD_LAYOUTS_BEGIN,
    });
    const { projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(`${process.env.REACT_APP_BUILDER_ENGINE}layout/`, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_LOAD_LAYOUTS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_LOAD_LAYOUTS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadLayoutsError() {
  return {
    type: EDITOR_LOAD_LAYOUTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_LOAD_LAYOUTS_BEGIN:
      return {
        ...state,
        loadLayoutsPending: true,
        loadLayoutsError: null,
      };

    case EDITOR_LOAD_LAYOUTS_SUCCESS:
      return {
        ...state,
        loadLayoutsPending: false,
        loadLayoutsError: null,
        layouts: action.data ? action.data : [],
      };

    case EDITOR_LOAD_LAYOUTS_FAILURE:
      return {
        ...state,
        loadLayoutsPending: false,
        loadLayoutsError: action.data.error,
      };

    case EDITOR_LOAD_LAYOUTS_DISMISS_ERROR:
      return {
        ...state,
        loadLayoutsError: null,
      };

    default:
      return state;
  }
}
